import VanillaModal from 'vanilla-modal';
// import eventBus from '@/plugins/eventBus';

function Modal({ node }) {
	if (!node || node.id === 'body') return false;

	const base = {
		el: node,
		clickOutside: true,
		modal: '.modal',
		modalInner: '.modal-inner',
		modalContent: '.modal-content',
		class: 'modal-visible',
		onOpen() {
			// eventBus.emit('modal:open');
		},
	};

	const modal = new VanillaModal(base);

	return () => {
		modal.destroy();
	};
}

export default Modal;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
